// Bloque «stat»: un número con su etiqueta.

import type { SiteBlockOf } from "../values";

const numberFormat = new Intl.NumberFormat("es", { maximumFractionDigits: 2 });

export function StatBlock({ block }: { block: SiteBlockOf<"stat"> }) {
  return (
    <div className="rounded-lg border bg-card p-4 text-card-foreground">
      <p className="text-sm text-muted-foreground">{block.label}</p>
      <p className="mt-1 text-3xl font-semibold tabular-nums text-primary" data-testid={`stat-${block.key}`}>
        {numberFormat.format(block.value)}
      </p>
    </div>
  );
}
